/**
 * 内置策略：SCAN/LOOK 扫描（设计文档 3.4 表 / F-007）。
 *
 * 优先把呼叫指派给「方向一致且将顺路经过该层」的正在扫梯的车，
 * 鼓励轿厢沿当前方向连续服务；无合适扫梯车时退化为最近空闲。
 * 轿厢自身的 LOOK 停靠选择由内核 nextStop 提供。
 */
import { greedyAssign } from '../greedy-assign';
import { travelTimeForFloorsMs } from '../../core/physics/kinematics';
import type { DispatchStrategy, InitContext, SnapshotView } from '../strategy-api';
import type { KinematicsParams } from '../../core/physics/kinematics';

const PASSED = 80_000; // 同向但已越过呼叫楼层
const OPPOSITE = 200_000; // 反向
const IDLE = 1_000; // 空闲车基础代价（略高，鼓励复用扫梯车；但仍优于反向/越过）

export function createScanLookStrategy(id = 'scan-look'): DispatchStrategy {
  let kin: KinematicsParams | undefined;
  return {
    id,
    init(ctx: InitContext) {
      kin = ctx.kinematics;
    },
    allocate(view: SnapshotView) {
      const k = kin!;
      return greedyAssign(view.cars, view.calls, (car, call) => {
        const eta = travelTimeForFloorsMs(Math.abs(car.floor - call.floor), k);
        if (car.state === 'idle') return IDLE + eta;
        const sameDir = car.direction === call.direction;
        const willPass =
          (call.direction === 1 && car.floor <= call.floor) ||
          (call.direction === -1 && car.floor >= call.floor);
        if (sameDir && willPass) return eta; // 顺路最优
        if (sameDir) return eta + PASSED; // 同向已越过
        return eta + OPPOSITE; // 反向
      });
    },
  };
}
